function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   list-style: none;\n   margin: 0;\n   padding: 0 1rem;\n   border-right: 1px solid ", ";\n\n   ", ":not(:last-child) {\n      margin-right: 1rem;\n   }\n\n   :last-of-type {\n      padding-right: 0;\n      border-right: 0;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { TopNavMenuItem } from './TopNavMenuItem';
var TopNavMenu = styled.ul(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.brandColors.darkBlue;
}, TopNavMenuItem);
export { TopNavMenu };